var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.3116 249.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        opacity: .3;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        opacity: .6;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.7682,
    y1: 166.4957,
    x2: 145.6796,
    y2: 416.4511,
    gradientTransform: "translate(.0707 416.8198) rotate(-5) scale(1 -1) skewX(4.9622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74a900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#74a900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#92d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#91d303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#8fcf0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#8bc91f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5897,
    stopColor: "#86c037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5972,
    stopColor: "#84bd41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6986,
    stopColor: "#84be3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    stopColor: "#86c233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    stopColor: "#8ac821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9401,
    stopColor: "#8fd109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9639,
    stopColor: "#92d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9747,
    stopColor: "#8ccc17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#86c135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84bd41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 81.5063,
    y1: 336.7776,
    x2: 140.5185,
    y2: 234.5656,
    gradientTransform: "translate(.0707 416.8198) rotate(-5) scale(1 -1) skewX(4.9622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74a900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.7613,141.6173c0-18.2078,14.8938-41.8467,33.0918-52.5393L183.407,17.2146c9.1697-5.3888,17.4923-6.4927,23.5034-3.9457l-16.3112-8.3248c-6.0043-2.5115-14.304-1.393-23.444,3.9767L39.6013,80.7841c-18.198,10.6926-33.0918,34.3349-33.0918,52.5427v105.6548l16.2518,8.2905v-105.6548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.8531,89.078L183.407,17.2146c18.201-10.6963,33.0952-4.554,33.0952,13.6505v39.4712c0,18.1977-14.8942,41.8433-33.0952,52.5362l-127.5539,71.8599c-18.198,10.6926-33.0918,34.3383-33.0918,52.5396v-105.6548c0-18.2078,14.8938-41.8467,33.0918-52.5393h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.3373,131.2469c-.8374.4835-1.6488,1.311-2.3041,2.3452-.6957-.857-1.8204-.9528-3.0415-.2478-.882.5092-1.7267,1.3891-2.3973,2.4926-.7011-.7532-1.791-.8091-2.9482-.141-.5693.3287-1.1307.8186-1.6383,1.4273l-.0042-9.9197c-.0046-2.5497-1.6557-3.7104-3.6802-2.5876-.9526.5211-1.8722,1.4989-2.5859,2.7395-.786,1.3671-1.2356,2.9212-1.233,4.2635l.0399,21.6911-1.6688-1.5228c-1.4138-1.2906-3.7124-.6486-5.721,1.6003-.7124.7971-1.2608,1.8239-1.5442,2.8917-.2956,1.1134-.2619,2.1564.0922,2.8611.0102.0209.0214.0405.0333.0594l9.6623,15.1993c.9589,1.5085,2.7279,1.7682,4.6166.6778l11.4736-6.6243c2.2686-1.3098,4.2605-4.4982,4.7363-7.5811,1.2076-7.8219,1.8198-15.4858,1.8198-22.7793v-4.3161c0-2.5747-1.663-3.7092-3.7073-2.5289v-.0002ZM48.6201,155.6273l-.0462-25.2082c-.0012-.6902.2227-1.4765.6145-2.1576.3106-.5403.6994-.9591,1.0947-1.1775.9084-.5038,1.6492.0872,1.6515,1.3174l.0043,19.2071c0,.6743.4642.9548,1.0346.6254s1.0345-1.1458,1.0345-1.82v-5.1026c0-1.2265.7348-2.6488,1.6382-3.1703s1.6382.0522,1.6382,1.2787v5.8724c0,.6739.4642.9544,1.0346.6251s1.0345-1.1458,1.0345-1.8197c0-.3936.0062-4.9831.0146-5.4439.108-1.1607.806-2.3922,1.6236-2.8642.9034-.5216,1.6382.0518,1.6382,1.2783v6.1613c0,.6739.4642.9544,1.0346.6251.5704-.3293,1.0346-1.1458,1.0346-1.8198v-5.1724c0-1.2265.7348-2.6484,1.6381-3.1699s1.6381.0519,1.6381,1.2784v4.3161c0,7.1328-.5986,14.6275-1.7792,22.2755-.2831,1.8334-1.4217,3.7026-2.7077,4.4451l-11.4736,6.6243c-1.1337.6546-2.2078.4794-2.8031-.4576l-9.639-15.1605c-.1169-.2512-.1249-.6177-.0221-1.0049.0912-.3435.2569-.6622.4665-.8968.3506-.3922.7179-.6962,1.0824-.9066.806-.4653,1.5969-.4724,2.1552.0374l3.5203,3.2125c.2738.2494.737.141,1.1521-.2709.4155-.4114.6941-1.0374.6931-1.5568h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.4659,145.1889c.1607.0211.3444-.0246.5312-.1324.362-.209.7024-.6333.888-1.1069.1422-.3617.1835-.7144.1165-.9927-.0671-.2779-.2347-.4483-.4716-.4793-3.387-.4443-5.4091-3.4953-5.4091-8.1619,0-7.2498,4.9912-16.0296,11.1263-19.5718,6.1351-3.5421,11.1264-.5256,11.1264,6.7242,0,2.0672-.3929,4.2707-1.1677,6.5497-.255.7503-.0473,1.3664.4629,1.3732.2474.0032.5278-.1342.7901-.39.2622-.2548.4745-.595.598-.9585.9196-2.7052,1.3859-5.3193,1.3859-7.7689,0-8.5979-5.9194-12.1752-13.1955-7.9744-7.276,4.2008-13.1954,14.6133-13.1954,23.2112,0,5.5338,2.3978,9.152,6.4141,9.6787v-.0002Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.5014,129.3239c.075.2709.249.4315.4901.452.1545.0129.3292-.0338.5049-.1352.3742-.2161.7205-.6553.9034-1.1467.6816-1.8305,1.042-3.6749,1.042-5.3333,0-5.3395-3.676-7.5611-8.1945-4.9523s-8.1946,9.0751-8.1946,14.4146c0,1.536.3117,2.8849.9015,3.9014.1264.2176.3408.3087.6039.2568.2632-.0516.5435-.2412.7891-.5322.2459-.2911.4279-.6494.5124-1.0091.0845-.3597.0616-.6776-.0648-.8952-.4464-.7695-.6727-1.7507-.6727-2.9165,0-3.9913,2.7478-8.8247,6.1254-10.7747s6.1254-.2896,6.1254,3.7018c0,1.2404-.2689,2.6188-.7779,3.9855-.1351.3628-.1683.7121-.0934.9831h-.0002Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.5293,133.3967l-8.5674-5.4922-2.2676,3.8652v7.8828l-3.5991,2.0781v-24.0088l3.5991-2.0781v11.9141l10.0435-17.7129,4.4634-2.5771-9.8989,17.0898,10.6909,6.4619-4.4639,2.5771Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.7153,108.049c0-1.1514.9717-2.6484,2.0869-3.293,1.1523-.665,2.0884-.2686,2.0884.8828,0,1.1523-.936,2.5918-2.0884,3.2568-1.1152.6445-2.0869.3057-2.0869-.8467ZM99.2192,130.1115v-17.3857l3.2393-1.8701v17.3857l-3.2393,1.8701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.4536,122.0832v-10.6904l-2.8799,1.6631v-2.8438l2.8799-1.6631v-4.752l3.2393-1.8701v4.752l3.5273-2.0361v2.8438l-3.5273,2.0361v9.9707c0,1.2236.5757,1.792,1.6924,1.1475.7549-.4365,1.4395-1.1553,1.7632-1.7031l.8281,1.9707c-.6841,1.042-1.6914,2.0918-3.3838,3.0684-2.7354,1.5791-4.1392.8418-4.1392-1.8936Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.7964,98.6823c3.2759-1.8911,5.2554-1.667,6.5156-.7021l-2.1597,3.2261c-1.0439-.873-2.4478-.7471-4.2119.2715-3.4194,1.9746-5.6157,5.8701-5.6157,9.4697s2.1963,4.9961,5.6157,3.0215c1.7642-1.0186,3.168-2.5498,4.2119-4.5918l2.1597.7324c-1.2603,2.4199-3.2397,4.9307-6.5156,6.8213-5.2554,3.0342-8.8545,1.1895-8.8545-4.0303s3.5991-11.1846,8.8545-14.2183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.8125,104.9436v-11.1943c0-2.8799-1.4756-2.8921-3.7075-1.6035-2.0166,1.1641-3.8516,3.4482-4.7876,5.2847v12.4175l-3.2393,1.8701v-24.0083l3.2393-1.8701v9.0703c1.1519-2.0684,3.4917-4.895,6.1548-6.4326,3.708-2.1406,5.5806-1.3506,5.5806,2.3213v12.2739l-3.2402,1.8711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.0684,78.8957c5.2188-3.0132,8.459-.8164,8.459,4.5107v.792l-13.751,7.939c.252,2.8057,2.4121,4.0068,5.9033,1.9912,1.8359-1.0601,3.8516-2.9434,5.1484-5.0239l1.5107,1.2505c-1.7275,2.6899-4.1748,5.0024-6.9824,6.6235-5.1836,2.9922-8.9995,1.5244-8.9995-3.9473,0-5.0391,3.6353-11.2051,8.7114-14.1357ZM151.7412,89.8181l10.6182-6.1304c-.0723-2.2622-1.6191-4.2485-5.291-2.1289-3.4922,2.0161-5.1475,5.7798-5.3271,8.2593Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.5322,83.7439v-11.123c0-2.8789-1.4766-2.9634-3.708-1.6748-2.0166,1.1641-3.8516,3.4482-4.7881,5.2847v12.418l-3.2393,1.8706v-17.3857l3.2393-1.8706v2.4473c1.1523-2.0684,3.4561-4.874,6.1553-6.4326,3.6729-2.1201,5.5801-1.2778,5.5801,2.394v12.2021l-3.2393,1.8701Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.37a5e64208dddf85b7e14c0a63fcd58d.svg";
export { ForwardRef as ReactComponent };